import { StreamData } from 'types/streamData'
import WidgetType from 'enums/WidgetType'
import { Metadata } from '../adaptor/metadata'
import resolveParentTextRelatedFields from './parentText/parentTextUtil'

export const parentTextRelatedFieldsResolver = (metadata: Metadata) => {
  if (
    (metadata.getWidgetType() &&
      metadata.getWidgetType() === WidgetType.SOCIAL_WEB_POPULAR_LINKS) ||
    metadata.getWidgetType() === WidgetType.AUDIENCE_POPULAR_LINKS ||
    metadata.isDeleted()
  ) {
    return { parentReplyToAuthors: [] as string[] } as StreamData
  }

  return {
    ...resolveParentTextRelatedFields(metadata)
  }
}

export default parentTextRelatedFieldsResolver
